const accommodations = [
  {
    name: "Playitas Aparthotel",
    badge: "Dla rodzin i grup",
    badgeColor: "bg-orange-500",
    image: "https://api.playitas.net/sites/default/files/styles/hero/public/2023-06/Playitas_Aparthotel_04.JPG?h=c74750f6&itok=JZ61cgPu",
    desc: "114 studiów i 96 apartamentów rozmieszczonych w siedmiu budynkach. Idealny wybór dla rodzin i przyjaciół.",
    rooms: [
      { icon: "ri-home-4-line", name: "Studia (36m²)", desc: "Pojemność do 4 osób, projekt dwupoziomowy", color: "text-orange-500" },
      { icon: "ri-building-line", name: "Apartamenty", desc: "Pojemność do 5 osób, oddzielna sypialnia", color: "text-orange-500" },
      { icon: "ri-restaurant-line", name: "Opcje wyżywienia", desc: "Śniadanie, półpensjonat lub pełny pensjonat", color: "text-orange-500" },
    ],
    tags: ["Klimatyzacja", "WiFi", "Kuchnia", "Taras/Balkon", "Widok na morze/ogród"],
    tagColor: "bg-gray-100 text-gray-700",
    popular: false,
  },
  {
    name: "Playitas Hotel",
    badge: "Dla par i singli",
    badgeColor: "bg-teal-500",
    image: "https://api.playitas.net/sites/default/files/styles/hero/public/2023-06/Playitas_Resort.jpg?h=c74750f6&itok=lnEzV0cd",
    desc: "167 pokoi dwuosobowych, 52 junior suite i 4 suite z basenem. Raj spokoju i relaksu.",
    rooms: [
      { icon: "ri-hotel-bed-line", name: "Pokoje dwuosobowe (24-30m²)", desc: "Widok na morze lub ogród", color: "text-teal-500" },
      { icon: "ri-vip-crown-line", name: "Junior Suites", desc: "Większa przestrzeń i udogodnienia", color: "text-teal-500" },
      { icon: "ri-water-flash-line", name: "Suites z basenem (76m²)", desc: "Taras 55m² z podgrzewanym basenem", color: "text-teal-500" },
    ],
    tags: ["Restauracja bufetowa", "Palapa Bar", "Basen podgrzewany", "Sale konferencyjne"],
    tagColor: "bg-teal-50 text-teal-700",
    popular: true,
  },
  {
    name: "Playitas Villas",
    badge: "Ekskluzywne",
    badgeColor: "bg-yellow-500",
    image: "https://api.playitas.net/sites/default/files/styles/hero/public/2021-03/P2546_Playitas_Jesper%20Andersson_Rooms%209_20171106-min.jpg?h=85aa78b5&itok=VoJBnPTB",
    desc: "24 wille w naturalnym, spokojnym otoczeniu blisko pola golfowego. Niezapomniane wakacje.",
    rooms: [
      { icon: "ri-home-smile-line", name: "2 sypialnie (20m² każda)", desc: "Każda z własną łazienką", color: "text-yellow-600" },
      { icon: "ri-water-flash-line", name: "Prywatny basen", desc: "Ekskluzywny basen tylko dla Ciebie", color: "text-yellow-600" },
      { icon: "ri-restaurant-2-line", name: "Opcje wyżywienia", desc: "Od B&B do pełnego pensjonatu", color: "text-yellow-600" },
    ],
    tags: ["Pełna kuchnia", "3 łazienki", "Prywatność", "Blisko pola golfowego"],
    tagColor: "bg-yellow-50 text-yellow-700",
    popular: false,
  },
];

export default function PlayitasAccommodation() {
  return (
    <section id="accommodation" className="py-32 px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-gray-500 text-sm tracking-widest mb-4">ZAKWATEROWANIE</p>
          <h2 className="text-5xl md:text-6xl font-bold mb-6">
            <span className="font-normal">Wybierz idealne</span><br />
            <span className="font-bold italic">zakwaterowanie dla swojej grupy</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Playitas Resort oferuje trzy rodzaje zakwaterowania dostosowane do różnych potrzeb i grup
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {accommodations.map((acc) => (
            <div key={acc.name}
              className={`bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all group ${acc.popular ? "border-4 border-teal-500 relative" : ""}`}>
              {acc.popular && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-teal-500 text-white px-6 py-2 rounded-full font-bold text-sm z-10 shadow-lg whitespace-nowrap">
                  ⭐ Najpopularniejszy
                </div>
              )}
              <div className="relative h-80 overflow-hidden">
                <img src={acc.image} alt={acc.name}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500" />
                <div className={`absolute top-6 right-6 ${acc.badgeColor} text-white px-4 py-2 rounded-full font-bold text-sm whitespace-nowrap`}>
                  {acc.badge}
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">{acc.name}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">{acc.desc}</p>
                <div className="space-y-3 mb-6">
                  {acc.rooms.map(r => (
                    <div key={r.name} className="flex items-start gap-3">
                      <i className={`${r.icon} text-xl mt-0.5 ${r.color}`} />
                      <div>
                        <p className="font-semibold text-gray-900">{r.name}</p>
                        <p className="text-sm text-gray-600">{r.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="border-t border-gray-200 pt-6">
                  <p className="text-sm font-semibold text-gray-700 mb-3">Udogodnienia:</p>
                  <div className="flex flex-wrap gap-2">
                    {acc.tags.map(tag => (
                      <span key={tag} className={`px-3 py-1 rounded-full text-xs font-medium ${acc.tagColor}`}>{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
            className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-500 to-teal-500 hover:opacity-90 text-white px-10 py-5 rounded-full font-bold text-lg transition-all cursor-pointer whitespace-nowrap shadow-xl hover:scale-105">
            <i className="ri-customer-service-2-line text-2xl" />
            SKONTAKTUJ SIĘ Z NAMI
            <i className="ri-arrow-right-line text-xl" />
          </button>
        </div>
      </div>
    </section>
  );
}
